module.exports = __webpack_public_path__ + "static/favicon-76c224d7fe5ffcc119d2e315d61b633b.png";